import React from "react";
import { Collapse, Divider, Typography, Row, Col } from "antd";

import { CompanyForm } from "./CompanyForm";
import { EmployeeForm } from "./EmployeeForm";
import { PermissionsForm } from "./PermissionsForm";

export const CreateEmployeeForms = ({
  form,
  onFinish,
  formData,
  isIntegrationAuthEnabled,
  dispatch,
}) => {
  const PANELS_KEYS = {
    EMPLOYEE: "employeeData",
    COMPANY: "companyData",
    ACCESS: "accessData",
  };

  const getPanelsKeysActiveByDefault = () => {
    return isIntegrationAuthEnabled
      ? Object.values(PANELS_KEYS)
      : Object.values(PANELS_KEYS).slice(0, 2);
  };

  return (
    <>
      <Typography.Title level={2} color={"#166889"}>
        Adicionar funcionário
      </Typography.Title>
      <Divider style={{ borderTop: "2px solid rgba(0, 0, 0, 0.06)" }} />
      <Collapse ghost defaultActiveKey={getPanelsKeysActiveByDefault()}>
        <Collapse.Panel
          header={
            <>
              <b>Dados do funcionário</b> <br /> Preencha as informações
              pessoais do funcionário.
            </>
          }
          key={PANELS_KEYS.EMPLOYEE}
        >
          <Divider
            style={{
              marginBottom: 24,
              marginTop: 0,
              borderTop: "2px solid rgba(0, 0, 0, 0.06)",
            }}
          />
          <EmployeeForm form={form} onFinish={onFinish} />
        </Collapse.Panel>
        <Collapse.Panel
          header={
            <>
              <b>Dados da empresa</b> <br /> Preencha as informações referentes
              a empresa, área, cargo e gestão do funcionário.
            </>
          }
          key={PANELS_KEYS.COMPANY}
        >
          <Divider
            style={{
              marginBottom: 24,
              marginTop: 0,
              borderTop: "2px solid rgba(0, 0, 0, 0.06)",
            }}
          />
          <CompanyForm
            form={form}
            onFinish={onFinish}
            formData={formData}
            dispatch={dispatch}
          />
        </Collapse.Panel>
        <Collapse.Panel
          header={
            <>
              <b>Gerenciar acessos</b> <br /> Habilite os acessos do funcionário
              aos sistema permitidos abaixo.
            </>
          }
          key={PANELS_KEYS.ACCESS}
          collapsible={isIntegrationAuthEnabled ? undefined : "disabled"}
        >
          <Divider
            style={{
              marginBottom: 24,
              marginTop: 0,
              borderTop: "2px solid rgba(0, 0, 0, 0.06)",
            }}
          />
          <PermissionsForm form={form} onFinish={onFinish} />
        </Collapse.Panel>
      </Collapse>
    </>
  );
};

export const RowCol = ({ children }) => (
  <Row>
    <Col span={24}>{children}</Col>
  </Row>
);
